import { useDispatch, useSelector } from "react-redux";
import { NotPersistAction } from "store/actions";
import SelectDeliveryArea from "components/outlet-based-areas/SelectDeliveryArea";
import SlideInLayout from "components/layouts/SlideInLayout";

function DeliveryAreaModal({preventStoreInfoFetching = false}) {
  const { areaModal } = useSelector((state) => state.NotPersist);
  const dispatch = useDispatch();

  return (
    <>
      <SlideInLayout
        open={areaModal}
        disableOutsideClick={true}
        handleClose={() => {
          dispatch(NotPersistAction.toggleAreaModal(false));
        }}
        container={{
          className: `py-2`,
        }}
       >
        <SelectDeliveryArea
          header={false}
          // error={areasError} 
          // headerLabel=""
          styleClasses={`h-full`} 
          preventStoreInfoFetching={preventStoreInfoFetching}
        />
      </SlideInLayout>
    </>
  );
}

export default DeliveryAreaModal;
